export const GET_POSTING_LAST_STEP = 'publicador/stepper/GET_POSTING_LAST_STEP';
export const UPDATE_LAST_STEP = 'publicador/stepper/UPDATE_LAST_STEP';
